import React from 'react'
import { Link } from 'react-router-dom'

import styles from "../UserRequestFile.module.css"
import Dstyles from "../../UserMyAds/UserMyAds.module.css";


export default function RequestAnswer({ data }) {
  return (
    <>
      {data?.map((item, i) => (
        <div className={`d-flex flex-column align-items-center justify-content-start p-4 my-4 ${Dstyles.main_container}`}>
          <Title title={`املاک پیشنهادی برای شما توسط ${item.consultantDto.fullName}`} />
          <div className='w-100 px-2 d-flex flex-column justify-content-center align-items-center my-3'>
            {item.suggestedFiles?.map((item, i) => (
              <div key={i} className={`w-100 d-flex align-items-center justify-content-between px-3 my-3 ${styles.box}`}>
                <div className={styles.box_title}>
                  {item?.estateDto?.title}
                </div>
                <div className='d-flex align-items-center justify-content-center'>
                  <span className={`ms-2 ${styles.box_text_gray}`}>شناسه فایل:</span>
                  <span className={styles.box_title}>
                    {item?.estateCode}
                  </span>
                </div>
                <Link className={styles.box_primary} to="#">
                  {/* to={{
                                    pathname: `/فایل/${item.slug}`,
                                    state: {
                                        state: item
                                    }
                                }} */}
                  بیشتر
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className='me-2'>
                    <path fillRule="evenodd" clipRule="evenodd" d="M6.15533 11.0303C5.86244 11.3232 5.38756 11.3232 5.09467 11.0303L0.59467 6.53033C0.301776 6.23744 0.301776 5.76256 0.59467 5.46967L5.09467 0.969671C5.38756 0.676777 5.86244 0.676777 6.15533 0.969671C6.44822 1.26256 6.44822 1.73744 6.15533 2.03033L2.93566 5.25L10.875 5.25C11.2892 5.25 11.625 5.58579 11.625 6C11.625 6.41421 11.2892 6.75 10.875 6.75L2.93566 6.75L6.15533 9.96967C6.44822 10.2626 6.44822 10.7374 6.15533 11.0303Z" fill="#21409A" />
                  </svg>

                </Link>
              </div>
            ))}
          </div>

          <div className='w-100 d-flex flex-column align-items-start justify-content-center my-4'>
            <div className={`mb-3 ${styles.box_text_gray}`}>
              توضیحات مشاور
            </div>
            <div className={`w-100 px-2 py-3 ${styles.box_description_container}`}>
              <div className={styles.box_description}>
                {item?.description}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

function Title({ title }) {
  return (
    <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-4'>
      <div className={`my-md-0 my-2 ${Dstyles.title}`}>
        {title}
      </div>
    </div>
  )
}
